export const normalizeTabName = (name = '') => {
  return `${name.toUpperCase()}_TAB_INDEX`;
};
